import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import dialogs from '@/components/common/dialogs'
import Full from '@/containers/Full'
import Login from '@/components/login/Login'
import Register from '@/components/login/Register'
import Agreement from '@/components/login/Agreement'
import Profile from '@/components/profile/Profile'
import ActionLogPage from '@/components/profile/ActionLogPage'
import ClientProfile from '@/components/client/ClientProfile'
import ClientPanel from '@/components/client/ClientPanel'
import PeoplePanel from '@/components/people/PeoplePanel'
import FavoriteCompanyPanel from '@/components/favorite/FavoriteCompanyPanel'
import MainPage from '@/components/MainPage'
import MonitoringPanel from '@/components/favorite/MonitoringPanel'
import AssistPanel from '@/components/assist/AssistPanel'
import DocList from '@/components/depo/DocList'
import DocForm from '@/components/depo/DocForm'
import DocDlg from '@/components/depo/DocDlg'
import ChatPanel from '@/components/chat/ChatPanel'
import Chat from '@/components/chat/Chat'
import NotImplemented from '@/components/NotImplemented'
import Test from '@/components/Test'
import NewWindow from '@/containers/NewWindow'
import Payment from '@/components/gate/Payment'

Vue.use(Router)

const router = new Router({
  from: {},
  routes: [
    {
      path: '/new_window',
      name: 'NewWindow',
      component: NewWindow
    },
    {
      path: '/',
      redirect: '/home',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'home',
          name: 'MainPage',
          component: MainPage,
          meta: { requiresAuth: false }
        },
        {
          path: 'file/:uid',
          name: 'DocDlg',
          component: DocDlg,
          meta: { requiresAuth: false }
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          meta: { requiresAuth: false }
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
          meta: { requiresAuth: false }
        },
        {
          path: 'agreement',
          name: 'Agreement',
          component: Agreement
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: 'profile_log',
          name: 'ActionLogPage',
          component: ActionLogPage
        },
        {
          path: 'client_profile',
          name: 'ClientProfile',
          component: ClientProfile
        },
        {
          path: 'doc_list/:folderName',
          name: 'DocList',
          component: DocList,
          children: [
            {
              path: 'doc/:uid',
              name: 'DocForm',
              component: DocForm
            }
          ],
          meta: { requiresAuth: false }
        },
        {
          path: 'chats/:chatId',
          name: 'ChatPanel',
          component: ChatPanel,
          meta: { requiresAuth: false }
        },
        {
          path: '/chat',
          name: 'Chat',
          component: Chat
        },
        {
          path: 'clients',
          name: 'ClientList',
          component: ClientPanel,
          meta: { requiresAuth: false }
        },
        {
          path: 'clients/:clientInn',
          name: 'ClientPanel',
          component: ClientPanel,
          meta: { requiresAuth: false }
        },
        {
          path: 'loners/:ogrnip',
          name: 'LonerPage',
          component: ClientPanel,
          meta: { requiresAuth: false }
        },

        {
          path: 'humans/:humanId',
          name: 'HumanPanel',
          component: ClientPanel,
          meta: { requiresAuth: false }
        },
        {
          path: 'fagency/:fagencyId',
          name: 'ForeignAgencyPanel',
          component: ClientPanel,
          meta: { requiresAuth: false }
        },
        {
          path: 'foreigns/:foreignId',
          name: 'ForeignPanel',
          component: ClientPanel,
          meta: { requiresAuth: false }
        },
        {
          path: 'favoritecompanies',
          name: 'FavoriteCompanyPanel',
          component: FavoriteCompanyPanel,
          meta: { requiresAuth: false }
        },
        {
          path: 'monitoring_page',
          name: 'MonitoringPage',
          component: MonitoringPanel,
          meta: { requiresAuth: false }
        },
        {
          path: 'cagents/:cagentId',
          name: 'CAgentPage',
          component: FavoriteCompanyPanel,
          meta: { requiresAuth: false }
        },
        {
          path: 'assist',
          name: 'AssistPanel',
          component: AssistPanel,
          meta: { requiresAuth: false }
        },
        {
          path: 'assist/:matterId',
          name: 'AssistPage',
          component: AssistPanel
        },
        {
          path: 'people',
          name: 'PeoplePanel',
          component: PeoplePanel,
          meta: { requiresAuth: false }
        },
        {
          path: 'people/:personId',
          name: 'PersonPage',
          component: PeoplePanel
        },
        {
          path: 'payment',
          name: 'Payment',
          component: Payment,
          meta: { requiresAuth: false }
        },
        {
          path: 'notImplemented',
          name: 'NotImplemented',
          component: NotImplemented
        },
        {
          path: 'test',
          name: 'Test',
          component: Test
        }

      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log('to', to, 'from', from, 'isModal', dialogs.isModal())
  if (dialogs.isModal()) {
    // Disable route if Modal dialog is opened
    next(false)
    return
  }
  if (to.name !== 'Login') {
    var isAuthorized = store.getters.getIsAuthorized(true)
    var isProfileLoaded = store.getters.getProfileLoaded
    if (!isAuthorized) {
      if (!(to.meta && to.meta.requiresAuth === false)) {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        })
      } else {
        next()
      }
    } else {
      if (!isProfileLoaded) {
        store.dispatch('fetchAccountProfile')
      }
      router.options.from = from
      next()
    }
  } else {
    next()
  }
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js